import {
  FETCH_GENRES_SUCCESS,
  FETCH_PLAYLIST_CAT_SUCCESS,
  FETCH_GEOS_SUCCESS,
  FETCH_STOCK_MUSIC_SUCCESS,
} from 'actions/targeting';

export const initialState = {
  availableGenres: [],
  availableGeos: [],
  availablePlaylistCategories: [],
  availableStockMusicTracks: [],
};

export default function targeting(state = initialState, action) {
  switch (action.type) {
    case FETCH_GENRES_SUCCESS:
      return {
        ...state,
        availableGenres: action.genres,
      };
    case FETCH_PLAYLIST_CAT_SUCCESS:
      return {
        ...state,
        availablePlaylistCategories: action.categories,
      };
    case FETCH_GEOS_SUCCESS:
      return {
        ...state,
        availableGeos: action.geos,
      };
    case FETCH_STOCK_MUSIC_SUCCESS:
      return {
        ...state,
        availableStockMusicTracks: action.tracks,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/targeting.js